.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 8px 16px;
    box-sizing: border-box;
    background-color: var(--off-white);
}
